export enum ClinicalDataTypeTypes {
  FreeText = 'free text',
  Integer = 'integer',
  MultiSelect = 'multiselect',
  Numeric = 'numeric',
  Options = 'list',
}
